<template>
    <a-spin :spinning="tableLoading">
        <div class="main">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Sales Reports</h3>

                <a-range-picker :default-value="[moment(startDate, dateFormat), moment(endDate, dateFormat)]"
                    :format="dateFormat" @change="onChange" style="cursor:pointer" />
            </div>

            <div style="padding-top:20px;">
                <a-row>
                    <a-col style="background:#fff;" :span="6">
                        <div style="display:flex;justify-content: center;padding-top:20px">
                            <i style="font-size: 30px;color:green;" class="fas fa-chart-line"></i>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:20px;font-weight:800">
                            <h4 style="font-weight:700">Ksh {{ displayCardData.totalSales ?
        displayCardData.totalSales.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 0
                                }}
                            </h4>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:10px">
                            <p>Gross Sales</p>
                        </div>
                    </a-col>
                    <a-col style="background:#fff" :span="5" :offset="1">
                        <div style="display:flex;justify-content: center;padding-top:20px">
                            <i style="font-size: 30px;color:green;" class="fas fa-chart-line"></i>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:20px;">
                            <h4 style="font-weight:700">Ksh {{ displayCardData.totalCostPrice ?
        displayCardData.totalCostPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) :
        0
                                }}</h4>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:10px">
                            <p>Cost of Goods</p>
                        </div>
                    </a-col>
                    <a-col style="background:#fff" :span="5" :offset="1">
                        <div style="display:flex;justify-content: center;padding-top:20px">
                            <i style="font-size: 30px;color:green;" class="fas fa-chart-line"></i>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:20px;font-weight:800">
                            <h4 style="font-weight:700">Ksh {{ displayCardData.totalProfit ?
        displayCardData.totalProfit.toLocaleString(undefined, { minimumFractionDigits: 2 }) : 0
                                }}
                            </h4>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:10px">
                            <p>Net Sales</p>
                        </div>
                    </a-col>
                    <a-col style="background:#fff" :span="5" :offset="1">
                        <div style="display:flex;justify-content: center;padding-top:20px">
                            <i style="font-size: 30px;color:green;" class="fas fa-chart-line"></i>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:20px;font-weight:800">
                            <h4 style="font-weight:700"> {{ marginCalculation ? marginCalculation.toFixed(2) : 0.0 }}%
                            </h4>
                        </div>
                        <div style="display:flex;justify-content: center;padding-top:10px">
                            <p>Margin</p>
                        </div>
                    </a-col>
                </a-row>
            </div>

            <!-- <div style="margin-top:40px;background:#fff;">
                <line-chart :chartData="chartdata" :chartOptions="options"></line-chart>
            </div> -->

            <div style="margin-top:40px;padding-bottom: 40px;">
                <div class="summary">
                    <p>{{ salesTitle }}</p>
                    <div>
                        <a-button :loading="exportLoading" @click="exportExcell"
                            style="height:31px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
                            icon="export">
                            Export
                        </a-button>
                        <a-select default-value="Daily" v-model="salesDatSelected" style="width: 120px"
                            @change="handleSalesChange">
                            <a-select-option value="daily">
                                Daily
                            </a-select-option>
                            <a-select-option value="monthly">
                                Monthly
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
                <a-table style="background:#fff;" :columns="columns" :data-source="tableData"
                    :pagination="salesTitle === 'Daily Sales Summary' ? pagination : false" class="tableStyle">
                </a-table>
            </div>
        </div>



    </a-spin>
</template>

<script>
import moment from 'moment';
// import LineChart from '../preorder/common/LineChart'
import { mapActions } from 'vuex';
import _ from 'lodash';
import XLSX from "xlsx";


const columns = [
    {
        title: 'Date',
        // width: 150,
        dataIndex: 'dailyDate',
        key: 'dailyDate'
    },
    {
        title: 'Quantity',
        dataIndex: 'totalQuantitySold',
        // width: 130,
    },
    {
        title: 'Gross Sales',
        dataIndex: 'totalSales',
        //  width: 50,
    },
    {
        title: 'Cost of Goods',
        dataIndex: 'totalCostPrice',
        // width: 150,
    },
    {
        title: 'Profits',
        dataIndex: 'totalProfit',
        // width: 150,
    }

];


const data = [
    {
        key: 1,
        date: '12-10-2012',
        quantitySold: 12,
        totalValue: 34,
        commission: 32,
        netSales: 345
    },
    {
        key: 2,
        date: '10-10-2012',
        quantitySold: 89,
        totalValue: 83,
        commission: 49,
        netSales: 485
    },
    {
        key: 3,
        date: '15-10-2012',
        quantitySold: 45,
        totalValue: 59,
        commission: 23,
        netSales: 945
    }
]


export default {
    name: 'SalesReport',
    components: {
        //   LineChart
    },
    data() {
        return {
            dateFormat: 'YYYY-MM-DD',
            // startDate: moment(),
            // endDate: moment(),
            columns,
            data,
            exportLoading: false,
            startDate: moment().startOf('year').format('YYYY-MM-DD'),
            endDate: moment().endOf('year').format('YYYY-MM-DD'),
            pagination: {
                pageSize: 12
            },
            tableLoading: false,
            params: {
                startDate: moment().startOf('year').format('YYYY-MM-DD'),
                endDate: moment().endOf('year').format('YYYY-MM-DD')
            },
            tableData: [],
            chartdata: null,
            salesTitle: "Daily Sales Summary",
            salesDatSelected: 'daily',
            options: null,
            cardInfo: {
                totalCommission: 0,
                totalCostPrice: 0,
                totalProfit: 0,
                totalQuantitySold: 0,
                totalSales: 0,
                totalNetSales: 0
            }
        };
    },
    computed: {
        displayCardData() {
            return this.cardInfo
        },
        marginCalculation() {
            return (this.cardInfo.totalProfit / this.cardInfo.totalSales) * 100
        }
    },
    methods: {
        ...mapActions(['getSalesReportsOverview', 'getMonthlySalesReportsOverview']),
        onChange(date, dateString) {
            this.startDate = dateString[0];
            this.endDate = dateString[1];
            this.params.startDate = this.startDate
            this.params.endDate = this.endDate
            this.salesDatSelected = 'daily';
            this.salesTitle = "Daily Sales Summary";
            this.loadSalesReport(this.params)

        },
        exportExcell() {

            this.exportLoading = true
            const dataToExport = [
                [
                    "Date",
                    "Quantity",
                    "Gross Sales",
                    "Cost of Goods",
                    "Profits"
                ],
            ];

            this.exportLoading = false;

            this.tableData.forEach((v) => {
                dataToExport.push([
                    v.dailyDate,
                    v.totalQuantitySold,
                    v.totalSales,
                    v.totalCostPrice,
                    v.totalProfit
                ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Sales-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        moment,
        handleSalesChange(value) {
            if (value === "daily") {
                // let request_data = {
                //     startDate:  moment().startOf('year').format('YYYY-MM-DD'),
                //     endDate:  moment().add(1,'d').format('YYYY-MM-DD')
                // }
                this.loadSalesReport(this.params)
                this.salesTitle = "Daily Sales Summary"
            } else {
                // let request_data = {
                //     startDate: moment().startOf('year').format('YYYY-MM-DD'),
                //     endDate: moment().endOf('year').format('YYYY-MM-DD'),
                // }
                this.loadMonthlySalesReport(this.params)
                this.salesTitle = "Monthly Sales Summary"
            }
        },

        async loadMonthlySalesReport(request_data) {
            this.tableLoading = true
            let final_request = {
                request_data,
                // request_data_2:{
                //     startDate: moment().startOf('year').format('YYYY-MM-DD'),
                //     endDate: moment().endOf('year').format('YYYY-MM-DD'),
                // }
            }
            let response = await this.getMonthlySalesReportsOverview(final_request)

            this.tableLoading = false
            let cardData = response[0].data
            let monthlySales = response[1].data.data
            this.cardInfo = {
                totalCommission: cardData.totalCommission,
                totalCostPrice: cardData.totalCostPrice,
                totalProfit: cardData.totalProfit,
                totalQuantitySold: cardData.totalQuantitySold,
                totalSales: cardData.totalSales,
                totalNetSales: cardData.totalProfit - cardData.totalCommission
            }

            let result = monthlySales.map(product => ({
                key: this.randomString(10),
                dailyDate: moment(product.monthlyDate).format('MMM-YYYY'),
                totalQuantitySold: product.totalQuantitySold,
                totalSales: product.totalSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                totalCostPrice: product.totalCostPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                totalProfit: product.totalProfit.toLocaleString(undefined, { minimumFractionDigits: 2 })
            }))

            // this.tableData = _.reverse(result)
            this.tableData = result
        },

        async loadSalesReport(request_data) {
            this.tableLoading = true
            let final_request = {
                request_data
                // request_data_2:{
                //     startDate: moment().startOf('year').format('YYYY-MM-DD'),
                //     endDate: moment().format('YYYY-MM-DD')
                // }
            }
            let response = await this.getSalesReportsOverview(final_request)

            this.tableLoading = false
            let cardData = response[0].data
            let dailySales = response[1].data.data
            this.cardInfo = {
                totalCommission: cardData.totalCommission,
                totalCostPrice: cardData.totalCostPrice,
                totalProfit: cardData.totalProfit,
                totalQuantitySold: cardData.totalQuantitySold,
                totalSales: cardData.totalSales,
                totalNetSales: cardData.totalProfit - cardData.totalCommission
            }


            let result = dailySales.map(product => ({
                key: this.randomString(10),
                dailyDate: moment(product.dailyDate).format('YYYY-MM-DD'),
                totalQuantitySold: product.totalQuantitySold,
                totalSales: product.totalSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                totalCostPrice: product.totalCostPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                totalProfit: product.totalProfit.toLocaleString(undefined, { minimumFractionDigits: 2 })
            }))

            this.tableData = _.reverse(result)
            // this.tableData = result
        }

    },
    created() {
        // if(this.getSalesRevenueReport){
        //     this.getSalesRevenueReport()
        // }
        if (this.loadSalesReport) {
            let request_data = {
                startDate: this.startDate,
                endDate: this.endDate
            }
            this.loadSalesReport(request_data)
        }
    }

}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.viewButton {
    background: #fff;
    color: #418a49;
    border-color: #418a49;
}

.summary {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

/* .wrapper {
  margin: 0 auto;
  max-height: 100% !important;
  max-width: 100% !important;
}

.container{
  display: flex;
  justify-content: center;
  align-content: center;
} */

.center-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    font-size: 40px;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>
